<template>
  <div id="inicio" class="home">
    
    <b-navbar toggleable="lg" type="dark" fixed="top" variant="">
      <b-container>
        <b-navbar-brand href="#">
          <img class="logo" src="../assets/logo.png">
          <img class="logo" src="../assets/residencial.svg">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#inicio">Inicio</b-nav-item>
            <b-nav-item href="#pilares">Pilares</b-nav-item>
            <b-nav-item href="#modelos">Modelos</b-nav-item>
            <b-nav-item class="btn-contact" href="#contacto">Contacto</b-nav-item>
            <b-nav-item target="_blank" href="https://www.facebook.com/Privadasanandres"><img src="../assets/Facebook.svg"></b-nav-item>
            <b-nav-item target="_blank" href="https://www.instagram.com/privadasanandres/"><img src="../assets/insta.svg"></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <!-- BANNER -->
    <div class="banner">
      <b-container>
        <b-row class="align-items-center">
          <b-col class="mb-5" lg="7">
            <h1>¡Más de lo importante!</h1>
            <p class="mb-5">¡Cuando eliges dónde vivir, no todo importa igual!</p>
            <p class="mb-0"> <img src="../assets/ubi.svg"/> Importa la ubicación que te ahorra tiempo.</p>
            <p class="mb-0"> <img src="../assets/house.svg"/> Importa el espacio que realmente necesitas.</p>
            <p class="mb-0"> <img src="../assets/price.svg"/> Importa que tu dinero se convierta en valor real.</p>
          </b-col>
          <b-col class="mb-5" lg="5">
            <div class="form-wrapper">
              <h4 class="text-center mb-4">¡Cotiza tu modelo favorito!</h4>
              <p class="error" v-if="messageSend">{{ messageSend }}</p>
              <div class="form-floating mb-3">
                <b-form-input class="mb-2 form-control" id="input-1" v-model="name" placeholder="Nombre y Apellido" required type="text"></b-form-input>
                <label>Nombre y Apellido</label>
              </div>
              <div class="form-floating mb-3">
                <b-form-input class="mb-2 form-control" id="input-3" v-model="email" placeholder="Email*" required type="text"></b-form-input>
                <label>Email</label>
              </div>
              <div class="form-floating mb-3">
                <b-form-input class="mb-2 form-control" id="input-4" v-model="phone" placeholder="Teléfono*" required type="text"></b-form-input>
                <label>Teléfono</label>
              </div>
              <b-form-textarea class="mb-4 form-control" id="input-6" v-model="message" placeholder="Escribenos un mensaje" rows="6" max-rows="3"></b-form-textarea>
              <b-form-input autocomplete="off" tabindex="-1" id="input-7" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
              <b-button class="btn-form-banner" v-on:click="sendMessage">Enviar mis datos</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div id="pilares"></div>
    <b-container>
      <b-row class="amenidades text-center">
        <b-col class="mb-4" md="12">
          <h3>Lo correcto se nota cuando comparas</h3>
          <p class="sub">Privada San Andrés no promete más .¡Entrega más de lo importante!</p>
        </b-col>
        <b-col md="4">
          <img class="img-fluid mb-3" src="../assets/mejorubi.svg">
          <p>Mejor ubicación</p>
        </b-col>
        <b-col md="4">
          <img class="img-fluid mb-3" src="../assets/masterreno.svg">
          <p>Más terreno</p>
        </b-col>
        <b-col md="4">
          <img class="img-fluid mb-3" src="../assets/masvalor.svg">
          <p>Más valor por tu inversión</p>
        </b-col>
        <b-col class="mb-3" offset-md="1" md="5">
          <a class="btn" href="#modelos">Ver modelos disponibles</a>
        </b-col>
        <b-col class="mb-3" md="5">
          <a class="btn" href="#contacto">Quiero que me contacten</a>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="cerca" fluid>      
      <b-row class="amenidades  text-center">
        <b-col class="mb-4" md="12">
          <h3>Más cerca de tu vida diaria</h3>
          <p class="sub">Donde llegar fácil también importa.</p>
        </b-col>
        <b-col md="6">
          <img class="img-fluid mb-3" src="../assets/gif_sanandres.gif">
        </b-col>
        <b-col md="6">
          <p><img class="img-fluid mb-4" src="../assets/mejorubi2.svg"> Mejor ubicación</p>
          <p class="text-left points mb-3"><img class="img-fluid" src="../assets/cercania.svg"> Cercanía a tus puntos de encuentro.</p>
          <p class="text-left points mb-3"><img class="img-fluid" src="../assets/reloj.svg"> Menos trayectos diarios: más tiempo para ti.</p>
          <p class="text-left points mb-3"><img class="img-fluid" src="../assets/location-pin.svg"> Conectado a servicios y zonas clave.</p>
          <a class="btn mt-5" href="#contacto">Agenda tu visita</a>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>   
      <b-row class="amenidades espacio text-center align-items-center">
        <b-col md="5">
          <img class="img-fluid mb-3" src="../assets/img1.png">
        </b-col>
        <b-col md="7">
          <h3>El espacio que sí se disfruta</h3>
          <p class="sub mb-4 text-left">Más m² de terreno para que tu casa se sienta amplia, respire y se adapte a tu vida.</p>
          <p class="mb-5"><img class="img-fluid" src="../assets/masterreno2.svg"> Más terreno</p>
          <p class="text-left mb-3 "><img class="img-fluid" src="../assets/bullet.svg"> La diferencia se nota desde que entras.</p>
          <p class="text-left mb-3 "><img class="img-fluid" src="../assets/bullet.svg"> Espacios mejor aprovechados.</p>
          <p class="text-left mb-3 "><img class="img-fluid" src="../assets/bullet.svg"> Vivir amplio se nota: libertad dentro de casa.</p>
          <a class="btn mt-5" href="">Quiero asesoría</a>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="dinero" fluid>      
      <b-row class="amenidades text-center">
        <b-col class="mb-4" md="12">
          <h3 class="mb-4">Más por tu dinero.</h3>
          <p class="sub mb-4">No es 'más barato'. Es mejor decidido,<br> para comprar sin arrepentimientos.</p>
        </b-col>
        <b-col class="mb-3" md="4">
          <img class="img-fluid mb-3" src="../assets/precios.svg">
          <p>Precios mejor posicionados en la zona por tipología.</p>
        </b-col>
        <b-col class="mb-3" md="4">
          <img class="img-fluid mb-3" src="../assets/masvalor2.svg">
          <p>Más valor por tu inversión</p>
        </b-col>
        <b-col class="mb-3" md="4">
          <img class="img-fluid mb-3" src="../assets/tranquilidad.svg">
          <p>Tranquilidad mes a mes: una inversión alineada a tu vida.</p>
        </b-col>
        <b-col md="12" class="text-center">
          <!-- <a class="btn-white btn mt-5 ml-2 mr-2" href="#">Recibir plan de financiamiento</a> -->
          <a class="btn-transparent btn mt-5 ml-2 mr-2" target="_blank" href="https://wa.link/jrm1id">Hablar por WhatsApp</a>
        </b-col>
      </b-row>
    </b-container>

    <b-container>      
      <div id="modelos"></div>
      <b-row class="modelos">
        <b-col md="12" class="text-center mb-5">
          <h3>Encuentra tu modelo ideal</h3>
        </b-col>
        <b-col class="mb-3 modelo-wrapper" md="12">
          <b-row class="align-items-center">
            <b-col md="4">
              <img class="img-fluid mb-3" src="../assets/anis.png" alt="">
            </b-col>
            <b-col md="8">
              <h5 class="mb-4">Modelo ANÍS <span style="padding: 5px 30px;font-weight: 800; font-family: 'Manrope', sans-serif; border-radius: 10px ;color: #fff; background: #0B5558"> AGOTADO </span></h5> 
              <p class="subtitle">Comodidad en una sola planta.</p>
              <p>Para quien busca practicidad diaria sin escaleras.</p>
              <ul>
                <li>Planta baja: todo a la mano.</li>
                <li>Espacios prácticos y bien resueltos.</li>
                <li>Ideal para pareja joven o familia pequeña.</li>
              </ul>
              <a class="btn btn-datasheet" target="_blank" :href="imgAnis">Recibir ficha técnica</a>
              <!-- <a href="">Ver recorrido virtual</a> -->
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mb-3 modelo-wrapper" md="12">
          <b-row>
            <b-col md="4">
              <img class="img-fluid mb-3" src="../assets/salvia.png" alt="">
            </b-col>
            <b-col md="8">
              <h5 class="mb-4">Modelo SALVIA</h5>
              <p class="subtitle">Una casa que crece contigo.</p>
              <p>Cuando tu vida cambia, tu casa debería acompañarte.</p>
              <ul>
                <li>Dos plantas bien pensadas: privacidad arriba, vida abajo.</li>
                <li>Dos recámaras con baños completos.</li>
                <li>Distribución inteligente: cada espacio tiene sentido.</li>
              </ul>
              <a class="btn btn-datasheet" target="_blank" :href="imgSalvia">Recibir ficha técnica</a>
              <!-- <a href="">Ver recorrido virtual</a> -->
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mb-3 modelo-wrapper" md="12">
          <b-row>
            <b-col md="4">
              <img class="img-fluid mb-3" src="../assets/magnolia.png" alt="">
            </b-col>
            <b-col md="8">
              <h5 class="mb-4">Modelo MAGNOLIA</h5>
              <p class="subtitle">El espacio que tu familia necesita.</p>
              <p>Magnolia es el modelo más grande, para vivir con amplitud y privacidad.</p>
              <ul>
                <li>3 recámaras: espacio real para crecer (familia, home office o visitas).</li>
                <li>2 niveles bien pensados: área social abajo, descanso arriba (más privacidad).</li>
                <li>Lote amplio para ampliar o disfrutar patio: más libertad, más posibilidades.</li>
              </ul>
              <a class="btn btn-datasheet" target="_blank" :href="imgMagnolia">Recibir ficha técnica</a>
              <!-- <a href="">Ver recorrido virtual</a> -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="decidir text-center">
        <b-col class="mb-4" md="12">
          <h3>Decidir bien es más fácil cuando el proceso es claro.</h3>
          <p class="sub">Te acompañamos paso a paso para que compres con tranquilidad.</p>
        </b-col>
        <b-col md="4">
          <img class="img-fluid mb-3" src="../assets/1.svg">
          <p>Agenda tu visita y conoce el<br> modelo ideal para tu etapa.</p>
        </b-col>
        <b-col md="4">
          <img class="img-fluid mb-3" src="../assets/2.svg">
          <p>Cotiza y revisa opciones de<br> financiamiento.</p>
        </b-col>
        <b-col md="4">
          <img class="img-fluid mb-3" src="../assets/3.svg">
          <p>Aparta y avanza con<br> documentación guiada.</p>
        </b-col>
        <b-col class="mt-5 mb-12 text-center">
          <a class="btn mb-3 ml-3 mr-3" href="#contacto">Agendar visita</a>
          <a class="btn mb-3 ml-3 mr-3" href="#inicio">Resolver dudas</a>
        </b-col>
      </b-row>

    </b-container>

    <!-- CONTACTO -->
    <div id="contacto" class="contacto">
      <b-container>
        <b-row>
          <b-col class="mb-3" md="12">
            <h2>Contáctanos</h2>
            <p><b>¡Elegir lo correcto se siente todos los días!</b></p>
          </b-col>
          <b-col class="mb-3" md="5">
            <p class="info-contacto mb-0"><img src="../assets/phone.svg" alt=""> 686 393 83 50</p>
            <p class="info-contacto mb-0"><img src="../assets/mail.svg" alt=""> Infoventas@idu.com.mx</p>
            <p class="info-contacto mb-4"><img src="../assets/address.svg" alt=""> Carretera San Felipe KM3 21383 Calle Río San Francisco C.P. 21383</p>
            <p class="info-contacto mb-0"><img src="../assets/hours.svg" alt=""> Horario de atención</p>
            <p class="info-contacto mb-0">Lunes a Viernes de 8am a 6pm</p>
            <p class="info-contacto mb-0">Sábados de 8am a 2pm</p>
            <p class="info-contacto mb-5">Domingo con previa cita.</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3362.0690328566643!2d-115.42740692423725!3d32.577682973747685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d7771430f249fd%3A0x98ba174a62cce31a!2sPrivada%20San%20Andres!5e0!3m2!1ses-419!2smx!4v1768428134393!5m2!1ses-419!2smx" height="300" style="border:0; width: 100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </b-col>
          <b-col class="mb-3" offset-md="1" md="6">
            <div class="form-floating mb-3">
              <b-form-input class="mb-2 form-control" id="input-1-2" v-model="namef" placeholder="Nombre y Apellido" required type="text"></b-form-input>
              <label>Nombre y Apellido</label>
            </div>
            <div class="form-floating mb-3">
              <b-form-input class="mb-2 form-control" id="input-3-2" v-model="emailf" placeholder="Email*" required type="text"></b-form-input>
              <label>Email</label>
            </div>
            <div class="form-floating mb-3">
              <b-form-input class="mb-2 form-control" id="input-4-2" v-model="phonef" placeholder="Teléfono*" required type="text"></b-form-input>
              <label>Teléfono</label>
            </div>

            <div class="form-floating mb-3">
              <b-form-input class="mb-2 form-control" id="input-4-2" v-model="visitarf" placeholder="Teléfono*" required type="text"></b-form-input>
              <label>¿Cuándo te gustaría visitar?</label>
            </div>
            <b-form-textarea class="mb-4 form-control" id="input-6-2" v-model="messagef" placeholder="Escribenos un mensaje" rows="6" max-rows="3"></b-form-textarea>
            <b-form-input autocomplete="off" tabindex="-1" id="input-7-2" class="pet-field" v-model="petf" placeholder="Alimento de mascota" type="text"></b-form-input>
            <p class="error" v-if="messageSendf">{{ messageSendf}}</p>
            <b-button class="btn-form-banner" v-on:click="sendMessageFooter">Enviar mis datos</b-button>
          </b-col>
          <b-col md="12" class="mt-5 text-center">
            <p class="footer-text">Imágenes ilustrativas para pauta publicitaria, pueden variar con el producto final.<br>
              Los precios están sujetos a cambios sin previo aviso. Aplica restricciones.</p>
          </b-col>
        </b-row>
      </b-container>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',
  data() {
    return {
      name: '',
      email: '', 
      phone: '',
      message: '',
      pet:'',
      namef: '',
      emailf: '', 
      phonef: '',
      visitarF: '',
      messagef: '',
      petf:'',
      messageSend: '',
      messageSendf: '',
      imgAnis: 'https://privadasanandres.com/FactSheets-SanAndres_ANIS.jpg',
      imgSalvia: 'https://privadasanandres.com/FactSheets-SanAndres_Salvia.jpg',
      imgMagnolia: 'https://privadasanandres.com/FactSheets-SanAndres_Magnolia.jpg',

    }
  },
  props: {
  },
  methods: {
    sendMessage: async function(){
      var responseData
      const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(this.email)) {
        this.messageSend = 'Ingresa un correo válido';
        return;
      }

      if(this.name != '' && this.email != '' && this.phone != '' && this.pet == ''){
        await axios.post('phpmailer.php', {
          fullname: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
        })
        .then((response) => {
          console.log(response)
          responseData = response
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        
        if(responseData.data == 200 || responseData.data == '200') {
          this.messageSend = 'Mensaje enviado exitosamente'
          this.name = ""
          this.email = ""
          this.phone = ""
          this.message = ""
        } else {
          this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
        }
      } else {
        this.messageSend = 'Ingresa la información necesaria en los campos.'
      }
    },
    sendMessageFooter: async function(){
      var responseData
      const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(this.emailf)) {
        this.messageSendf = 'Ingresa un correo válido';
        return;
      }

      if(this.namef != '' && this.emailf != '' && this.phonef != '' && this.petf == ''){
        await axios.post('phpmailerF.php', {
          fullname: this.namef,
          email: this.emailf,
          phone: this.phonef,
          dateV: this.visitarf,
          message: this.messagef
        })
        .then((response) => {
          console.log(response)
          responseData = response
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          /* eslint-enable no-console */
        });
        
        if(responseData.data == 200 || responseData.data == '200') {
          this.messageSendf = 'Mensaje enviado exitosamente'
          this.namef = ""
          this.emailf = ""
          this.phonef = ""
          this.visitarf = ""
          this.messagef = ""
        } else {
          this.messageSendf = 'Error al enviar mensaje, intenta mas tarde.'
        }
      } else {
        this.messageSendf = 'Ingresa la información necesaria en los campos.'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
  font-family: "spectral", sans-serif;
  font-weight: 600;
  font-size: 85px;
  line-height: 1; 
}
h2{
  font-family: "spectral", sans-serif;
  font-weight: 600;
  font-size: 70px;
}
h3{
  font-family: "spectral", sans-serif;
  font-weight: 600;
  font-size: 50px;
}
h4{
  font-family: "spectral", sans-serif;
  font-weight: 600;
  font-size: 30px;
}
h5{
  font-family: "spectral", sans-serif;
  font-weight: 500;
  font-size: 30px;
}
.text-left{
  text-align: left;
}
.cerca .points{
  position: relative;
  padding-left: 40px;
}
.espacio .points{
  position: relative;
  padding-left: 30px;
}
.points img{
  position: absolute;
  left: 0;
}

/* MENU */
.logo{
  max-width: 165px;
}
.navbar{
  background: #0B5558;
}
.navbar-dark .navbar-nav .nav-link{
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  padding-left: 15px;
  padding-right: 15px;
}
.navbar-nav{
  align-items: center;
}

.btn-contact{
  background: #E97F25;
  border-radius: 10px;
  border: none;
}

/* BANNER */
.banner{
  background-image: url("../assets/flower.svg"); /* The image used */
  background-color: #0B5558; /* Used if the image is unavailable */
  background-position: right center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: auto 60%;
  color: #fff;
  padding-top: 200px;
  padding-bottom: 100px;
}
.banner p{
  font-size: 25px;
}
.banner .btn{
  background: #E97F25;
  color: #fff;
  padding-left: 25px;
  padding-right: 25px;
  border: none;
  height: 60px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 20px;
  align-content: center;
}

.form-wrapper{
  background: #FFF;
  color: #000;
  padding: 45px 56px;
  border-radius: 20px;
  width: 100% !important;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.error{
  font-size: 16px !important;
}

.form-wrapper .form-control{
  border: solid 1px #000;
  font-size: 20px;
  border-radius: 10px;
}
.form-wrapper input{
  height: 70px;
}
.form-floating>label{
  font-size: 20px;
}

.btn-form-banner{
  color: #fff;
  background: #E97F25 !important;
  width: 100%;
  border: none;
  font-weight: 600;
  height: 70px;
  font-size: 20px;
  border-radius: 10px;
}

.sub{
  font-weight: 600;
  font-size: 30px !important;
  font-family: "Manrope", sans-serif;
}

/* FORM */
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
.btn{
  color: #fff;
  background: #E97F25 !important;
  width: 100%;
  border: none;
  font-weight: 600;
  font-size: 20px;
  padding: 10px 15px;
  border-radius: 10px;
  font-family: "Manrope", sans-serif;
}
.btn:hover,
.btn:focus{
  color: #fff;
}

/* AMEDIDADES */
.amenidades{
  padding: 5% 10%;
  border-radius: 20px;
  margin-top: 10%;
  margin-bottom: 10%;
}
.amenidades p{
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: 20px;
}

/* MAS CERCA DE TU VIDA DIARIA */
.cerca{
  background: #0B5558;
  color: #fff;
}
.cerca p{
  margin-top: 0px;
  margin-bottom: 10px;
  font-size: 20px;
}
.cerca .btn{
  max-width: 330px;
  margin-left: auto;
  margin-right: auto;
}

/* ESPACIO */
.espacio .btn{
  max-width: 330px;
  margin-left: auto;
  margin-right: auto;
}

/* DINERO */
.dinero{
 background: #0B5558;
 color: #fff;
}
.btn-white{
  color: #0B5558 !important;
  background: #fff !important;
  border: 1px solid #fff;
  width: fit-content;
}
.btn-transparent{
  border: 1px solid #fff;
  background: transparent !important;
  width: fit-content;
}
/* MODELOS */
.modelos .btn{
  background: #E97F25;
  color: #fff;
  border: none;
  font-weight: 600;
  font-size: 20px;
  border-radius: 10px;
}

.btn-datasheet{
  border: 1px solid #E97F25 !important;
  width: fit-content;
  background: transparent !important;
  color: #E97F25 !important;
  border-radius: 10px;
}
.modelos p,
.modelos ul{
  font-size: 20px;
}
.modelo-wrapper{
  background: #0B55581A;
  border-radius: 20px;
  padding: 50px;
}
.modelo-wrapper .subtitle{
  font-weight: 600;
  font-family: "Manrope", sans-serif;
}

/* DECIDIR */
.decidir{
  padding-top: 10%;
  padding-bottom: 10%;
}
.decidir .btn{
  max-width: 330px;
}

/* CONTACTO */
.contacto{
  background-image: url("../assets/img_footer.svg"); /* The image used */
  background-color: #0B5558; /* Used if the image is unavailable */
  background-position: left bottom; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: auto auto;
  padding-top: 8%;
  padding-bottom: 5%;
  color: #fff;
  font-size: 20px;
}
.info-contacto{
  padding-left: 25px;
  position: relative;
}
.info-contacto img{
  position: absolute;
  left: 0;
  top: 7px;
}

.contacto iframe{
  border-radius: 20px;
}

.contacto .btn{
  background: #E97F25 !important;
  color: #fff;
  border: none;
}

.contacto .form-control{
  border: solid 1px #fff;
  color: #fff;
  font-size: 20px;
  border-radius: 10px;
  background: transparent;
}
.contacto input{
  height: 70px;
}

.contacto label,
.contacto textarea::placeholder{
  color: #fff;
}

.footer-text{
  color: #FFFFFF4D;
  font-size: 16px;
}

@media (min-width: 1300px) {
    .container, .container-sm, .container-md, .container-lg, .container-xl {
        max-width: 1240px;
    }
}
@media (min-width: 1650px) {
    .container, .container-sm, .container-md, .container-lg, .container-xl {
        max-width: 1500px;
    }
}
@media (max-width: 1600px) {
    h1{
      font-size: 75px;
    }
    h2{
      font-size: 65px;
    }
    h3{
      font-size: 45px;
    }
    h4{
      font-size: 30px;
    }
    h5{
      font-size: 30px;
    }
    .banner p{
      font-size: 25px;
    }
    .banner .btn{
      height: 60px;
      font-size: 20px;
    }
}
@media (max-width: 991px) {
      /* MENU */
    .logo{
      max-width: 105px;
    }
    h1{
      font-size: 55px;
    }
    h2{
      font-size: 45px;
    }
    h3{
      font-size: 40px;
    }
    h4{
      font-size: 30px;
    }
    h5{
      font-size: 25px;
    }

    /* BANNER */
    .banner{
      background-size: auto 60%;
      color: #fff;
      padding-top: 200px;
      padding-bottom: 100px;
    }
    .banner p{
      font-size: 20px;
    }
    .banner .btn{
      height: 60px;
      font-size: 18px;
    }

    .form-wrapper{
      padding: 45px 50px;
    }

    .error{
      font-size: 14px !important;
    }

    .form-wrapper .form-control{
      border: solid 1px #000;
      font-size: 17px;
      border-radius: 10px;
      width: 100%;
    }
    .form-wrapper input{
      height: 50px;
      width: 100%;
    }
    .form-floating>label{
      font-size: 17px;
    }

    .btn-form-banner{
      height: 60px;
      font-size: 18px;
    }

    /* NOSOTROS */
    .nosotros{
      padding-top: 10%;
      padding-bottom: 10%;
    }
    .nosotros p{
      font-size: 20px;
    }
    .nosotros .icon{
      width: 44px;
    }


    /* AMEDIDADES */
    .amenidades{
      padding: 5% 10%;
    }
    .amenidades p{
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 20px;
    }

    /* MODELOS */
    .modelos .btn{
      width: 100%;
      font-size: 18px;
      height: 50px;
      margin-bottom: 30px;
    }
    .modelos p{
      font-size: 18px;
    }


    /* CONTACTO */
    .contacto{
      font-size: 18px;
    }
    .info-contacto{
      padding-left: 25px;
      position: relative;
    }
    .info-contacto img{
      position: absolute;
      left: 0;
      top: 7px;
    }

    .contacto iframe{
      border-radius: 20px;
    }

    .contacto .btn{
      background: #E97F25 !important;
      color: #fff;
      border: none;
      font-size: 18px;
    }

    .contacto .form-control{
      font-size: 17px;
      width: 100%;
    }
    .contacto input{
      height: 50px;
      width: 100%;
    }

    .contacto label,
    .contacto textarea::placeholder{
      color: #fff;
    }

    .footer-text{
      color: #FFFFFF4D;
      font-size: 14px;
    }
}
@media (max-width: 768px) {
  
}
@media (max-width: 576px) {  
  /* MENU */
    .logo{
      max-width: 85px;
    }
    h1{
      font-size: 46px;
    }
    h2{
      font-size: 45px;
    }
    h3{
      font-size: 30px;
    }
    h4{
      font-size: 25px;
    }
    h5{
      font-size: 25px;
    }
    .sub{
      font-weight: 600;
      font-size: 20px !important;
      font-family: "Manrope", sans-serif;
    }

    /* BANNER */
    .banner{
      background-size: auto 60%;
      padding-top: 120px;
      padding-bottom: 100px;
    }
    .banner p{
      font-size: 16px;
    }
    .banner p>img{
      width: 20px;
    }
    .banner .btn{
      height: 60px;
      font-size: 16px;
    }

    .form-wrapper{
      padding: 45px 50px;
    }

    .error{
      font-size: 14px !important;
    }

    .form-wrapper .form-control{
      border: solid 1px #000;
      font-size: 17px;
      border-radius: 10px;
      width: 100%;
    }

    .form-wrapper input{
      height: 50px;
      width: 100%;
    }
    .form-floating>label{
      font-size: 17px;
    }

    .btn-form-banner{
      height: 60px;
      font-size: 18px;
    }

    /* NOSOTROS */
    .nosotros{
      padding-top: 25%;
      padding-bottom: 15%;
    }
    .nosotros p{
      font-size: 20px;
    }
    .nosotros .icon{
      width: 44px;
    }


    /* AMEDIDADES */
    .amenidades{
      padding: 15% 15px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
    .amenidades p{
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 18px;
    }

    /* MODELOS */
    .modelos{
      padding: 15px;
    }
    .modelos .btn{
      width: 100%;
      font-size: 18px;
      height: 50px;
    }
    .modelos img{
      width: 100%;
    }
    .modelos p{
      font-size: 18px;
    }


    /* CONTACTO */
    .contacto{
      font-size: 18px;
    }
    .info-contacto{
      padding-left: 25px;
      position: relative;
    }
    .info-contacto img{
      position: absolute;
      left: 0;
      top: 7px;
    }

    .contacto iframe{
      border-radius: 20px;
    }

    .contacto .btn{
      background: #E97F25 !important;
      color: #fff;
      border: none;
      font-size: 18px;
    }

    .contacto .form-control{
      font-size: 17px;
      width: 100%;
    }
    .contacto input{
      height: 50px;
      width: 100%;
    }

    .contacto label,
    .contacto textarea::placeholder{
      color: #fff;
    }

    .footer-text{
      color: #FFFFFF4D;
      font-size: 14px;
    }
}

</style>
